import { render, staticRenderFns } from "./NavPillsSection.vue?vue&type=template&id=20fd2707&"
import script from "./NavPillsSection.vue?vue&type=script&lang=js&"
export * from "./NavPillsSection.vue?vue&type=script&lang=js&"
import style0 from "./NavPillsSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NavPillsSection.vue"
export default component.exports